export const KEYS = {
  accessToken: 'access_token',
  idToken: 'id_token',
  expiresAt: 'expires_at',
  profile: 'profile',
} as const;
